module.exports = __webpack_public_path__ + "static/media/PersonalInfo.6a705ae5.svg";